import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { makeStyles } from "@material-ui/core/styles";
import HotelIcon from "@material-ui/icons/Hotel";
import HomeIcon from "@material-ui/icons/Home";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import PeopleIcon from "@material-ui/icons/People";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import StorageIcon from "@material-ui/icons/Storage";

// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";

// Views
import DormitoryStaffManagement from "views/Dormitory/DormitoryStaffManagement.js";
import DormitoryMasterData from "views/Dormitory/DormitoryMasterData.js";
import { checkDormitoryMasterDataPermission } from "views/Dormitory/dormitoryAuth.js";

let ps;

const useStyles = makeStyles(styles);

export default function DormitoryLayout({ ...rest }) {
  const classes = useStyles();
  const mainPanel = React.createRef();
  const [image] = useState(bgImage);
  const [color] = useState("green");
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  const canManageMasterData = checkDormitoryMasterDataPermission();

  const routes = [
    {
      name: "จัดการหอพักและห้องพัก",
      icon: HotelIcon,
      component: DormitoryStaffManagement,
      layout: "/dormitory",
      path: "/manage"
    },
    {
      name: "จัดการข้อมูลหลัก (Master Data)",
      icon: StorageIcon,
      component: DormitoryMasterData,
      layout: "/dormitory",
      path: "/master-data",
      hidden: !canManageMasterData
    },
    {
      name: "กลับสู่หน้าหลัก",
      icon: HomeIcon,
      layout: "/home",
      path: "/index"
    }
  ];

  const switchRoutes = (
    <Switch>
      <Route path="/dormitory/manage" component={DormitoryStaffManagement} />
      {canManageMasterData && (
        <Route path="/dormitory/master-data" component={DormitoryMasterData} />
      )}
      <Redirect from="/dormitory" to="/dormitory/manage" />
    </Switch>
  );

  return (
    <div className={classes.wrapper} style={{ fontFamily: '"Sarabun", sans-serif' }}>
      <style>{`
        body, button, input, select, textarea, .btn, .badge, .card, .table, .modal {
          font-family: "Sarabun", sans-serif !important;
        }
      `}</style>
      <Sidebar
        routes={routes}
        logoText={"หอพักและห้องพัก"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        <div className={classes.content}>
          <div className={classes.container}>{switchRoutes}</div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
